import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
declare var $: any;
import * as _ from 'lodash';
import * as moment from 'moment';
import { DocumentManagementMasterService } from 'src/app/services/document-management-master.service';
import { AlertComponent } from '../../alert/alert.component';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';
import { DocxtemplateService } from 'src/app/services/docxtemplate.service';
@Component({
  selector: 'app-docx-templates',
  templateUrl: './docx-templates.component.html',
  styleUrls: ['./docx-templates.component.css']
})
export class DocxTemplatesComponent implements OnInit {

  public environmentSettings: any;
  agendaDocsToUpload: Array<File>;
  indexDocsToUpload: Array<File>;
  noticeDocsToUpload: Array<File>;
  individualDocsToUpload: Array<File>;
  FileOrignalName: any;
  changedName: any;
  templateFileName: any;
  templateDocId = '';
  downloadSingleFile = environment.pssServerUrl + 'documentManagement/downloadSingleFileOnID/';
  indexTemplateFileName: any;
  indexTemplateDocId = '';
  noticeTemplateFileName: any;
  noticeTemplateDocId = '';
  uploadIndexDoc: boolean = false;
  uploadDoc: boolean = false;
  fileExtension: any;
  changefileExtension: boolean = true;
  extensionCheck: boolean = true;
  isExtensionTrue: boolean = true;
  agendaIndividualTemplateFileName: any;
  agendaIndividualTemplateDocId = '';
  minuteTemplateFileName: any;
  minuteTemplateDocId = '';
  btnFor: any;
  indFileExtension: boolean = true;
  minuteIndividualTemplateFileName: any;
  minuteIndividualTemplateDocId = '';
  constructor(private meetingService: MeetingMasterService,
    private documentManagementMasterService: DocumentManagementMasterService,
    private docxtemplateService: DocxtemplateService,
    private alert: AlertComponent,
    public commonFunction: CommonFunction) { }

  ngOnInit() {
    this.environmentSettings = environment;
    this.getDocxTemplates();
    this.getAgendaTemplate();
  }

  uploadTemplate() {
    this.uploadDoc = true;
    var company = localStorage.getItem("companyDetails");
    // console.log(JSON.parse(company).companyID);
  }

  initiateUploadAgendaDocs() {
    this.getAgendaTemplate();
    this.uploadDoc = false;
    this.uploadIndexDoc = false;
    $("#AgendaDocumentUploadTitle").html("Template For Agenda");
    $("#agendaDocxUploadDialog").modal('toggle');
  }

  initiateUploadIndexDocs() {
    this.getAgendaTemplate();
    this.uploadIndexDoc = false;
    $("#AgendaIndexUploadTitle").html("Template For Agenda Index");
    $("#indexTemplateUploadDialog").modal('toggle');
  }

  agendaDocsChangeEvent(fileInput: any) {
    // var inputMime = fileInput.target.files[0].type;
    // this.agendaDocsToUpload = <Array<File>>fileInput.target.files;
    // fileInput = null;

    var checkfile = this.checkFileExtension(fileInput);
    if (checkfile) {
      var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileInput, fileInput)
      if (filenameValidation == "Valid") {
        this.extensionCheck = true;
        var inputMime = fileInput.target.files[0].type;
        this.agendaDocsToUpload = <Array<File>>fileInput.target.files;
        fileInput = null;
      } else {
        this.alert.error(filenameValidation);
      }
    } else {
      this.extensionCheck = false;
      this.alert.error("Invalid file extension")
    }
  }

  uploadAgendaDocFile() {
    var file = this.agendaDocsToUpload;
    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var documentName = this.FileOrignalName;
        var documentManagement = {
          "DocumentManagement": {
            DocumentName: Date.now() + '-' + documentName,
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: null,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }
        this.documentManagementMasterService.addDocumentManagement(documentManagement)
          .subscribe((docResponse:any) => {
            if (docResponse.status == 0) {
              var addedDocumentData = docResponse.result;
              var agendaTemplateObj = {
                "DocName": documentName,
                "uploadFileName": this.changedName,
                "DocumentManagementID": addedDocumentData._id
              }
              var company = localStorage.getItem("companyDetails");
              // console.log(JSON.parse(company).companyID);
              this.meetingService.addAgendaTemplateFile(agendaTemplateObj, JSON.parse(company).companyID)
                .subscribe(responseData => {
                  if (responseData.Status == 0) {
                    $("#agendaDocxUploadDialog").modal('toggle');
                    this.templateFileName = responseData.Data.DocName;
                    this.getAgendaTemplate();
                    this.alert.success("Template Uploaded Successfully");
                  } else {
                    this.alert.error("Something went wrong");
                  }
                })
            } else {
              this.alert.error("Something went wrong");
            }
          });
        this.agendaDocsToUpload = [];
      } else {
        this.alert.error("Oops, Something Went Wrong");
      }
    }, (error) => {

      this.alert.error("Invalid file.");
    })
  }

  indexDocsChangeEvent(fileInput: any) {
    // this.indexDocsToUpload = <Array<File>>fileInput.target.files;

    if (this.checkFileExtension(fileInput)) {
      var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileInput,fileInput)
      if(filenameValidation == "Valid"){
        this.indexDocsToUpload = <Array<File>>fileInput.target.files;
      this.changefileExtension = true;
      } else {
        this.alert.error(filenameValidation);
      }
    } else {
      this.changefileExtension = false;
      this.alert.error("Invalid file extension")
    }
  }

  uploadIndexTemplate() {
    this.uploadIndexDoc = true;
    var company = localStorage.getItem("companyDetails");
    // console.log(JSON.parse(company).companyID);
  }

  uploadIndexTemplateFile() {
    var file = this.indexDocsToUpload;
    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var documentName = this.FileOrignalName;
        var documentManagement = {
          "DocumentManagement": {
            DocumentName: Date.now() + '-' + documentName,
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: null,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }
        this.documentManagementMasterService.addDocumentManagement(documentManagement)
          .subscribe((docResponse:any) => {
            if (docResponse.status == 0) {
              var addedDocumentData = docResponse.result;
              var agendaTemplateObj = {
                "IndexTemplateName": documentName,
                "UploadIndexFileName": this.changedName,
                "IndexDocumentManagementID": addedDocumentData._id
              }
              var company = localStorage.getItem("companyDetails");
              // console.log(JSON.parse(company).companyID);
              this.meetingService.addIndexTemplateFile(agendaTemplateObj, JSON.parse(company).companyID)
                .subscribe(responseData => {
                  if (responseData.Status == 0) {
                    $("#indexTemplateUploadDialog").modal('toggle');
                    this.indexTemplateFileName = responseData.Data.IndexTemplateName;
                    this.getAgendaTemplate();
                    this.alert.success("Template Uploaded Successfully");
                  } else {
                    this.alert.error("Something went wrong");
                  }
                })
            } else {
              this.alert.error("Something went wrong");
            }
          });
        this.indexDocsToUpload = [];
      } else {
        this.alert.error("Oops, Something Went Wrong");
      }
    }, (error) => {

      this.alert.error("Invalid file");
    })
  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      var now = Date.now();
      for (var i = 0; i < files.length; i++) {
        formData.append("file", files[i], now + '-' + files[i].name.replace(',', ''));
        this.FileOrignalName = files[i].name.replace(',', '');
        this.changedName = now + '-' + files[i].name.replace(',', '');
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      var token = localStorage.getItem('token')
      xhr.open("POST", url, true);
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  getAgendaTemplate() {
    var company = localStorage.getItem("companyDetails");
    // console.log(JSON.parse(company).companyID);
    this.meetingService.getAgendaTemplateData(JSON.parse(company).companyID).subscribe(templateRes => {
      if (templateRes.Data) {
        if (templateRes.Data.DocumentManagementID != null) {
          this.templateFileName = templateRes.Data.DocName;
          this.templateDocId = templateRes.Data.DocumentManagementID;
        } else {
          this.templateFileName = 'File Not Available';
          this.templateDocId = null;
        }

        if (templateRes.Data.IndexDocumentManagementID != null) {
          this.indexTemplateFileName = templateRes.Data.IndexTemplateName;
          this.indexTemplateDocId = templateRes.Data.IndexDocumentManagementID;
        } else {
          this.indexTemplateFileName = 'File Not Available';
          this.indexTemplateDocId = null;
        }
      } else {
        this.templateFileName = 'File Not Available';
        this.templateDocId = null;
        this.indexTemplateFileName = 'File Not Available';
        this.indexTemplateDocId = null;
      }

    })
  }

  initiateUploadNoticeDocs() {
    this.getAgendaTemplate();
    this.uploadIndexDoc = false;
    $("#noticeUploadTitle").html("Template For Notice");
    $("#noticeTemplateUploadDialog").modal('toggle');
  }

  noticeDocsChangeEvent(fileInput: any) {
    // var inputMime = fileInput.target.files[0].type;
    // this.noticeDocsToUpload = <Array<File>>fileInput.target.files;
    // fileInput = null;
    if (this.checkFileExtension(fileInput)) {
      var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileInput, fileInput)
      if (filenameValidation == "Valid") {
        var inputMime = fileInput.target.files[0].type;
        this.noticeDocsToUpload = <Array<File>>fileInput.target.files;
        fileInput = null;
        this.isExtensionTrue = true;
      } else {
        this.alert.error(filenameValidation);
      }
    } else {
      this.isExtensionTrue = false;
      this.alert.error("Invalid file extension")
    }
  }

  uploadNoticeTemplateFile() {
    var file = this.noticeDocsToUpload;
    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var documentName = this.FileOrignalName;
        var documentManagement = {
          "DocumentManagement": {
            DocumentName: Date.now() + '-' + documentName,
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: null,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }
        this.documentManagementMasterService.addDocumentManagement(documentManagement)
          .subscribe((docResponse:any) => {
            if (docResponse.status == 0) {
              var addedDocumentData = docResponse.result;
              var agendaTemplateObj = {
                "DocName": documentName,
                "UploadFileName": this.changedName,
                "DocumentManagementID": addedDocumentData._id
              }
              this.docxtemplateService.addNoticeTemplate(agendaTemplateObj)
                .subscribe(responseData => {
                  if (responseData.status == 0) {
                    $("#noticeTemplateUploadDialog").modal('toggle');
                    this.noticeTemplateFileName = responseData.Data.NoticeTemplate.IndexTemplateName;
                    this.getDocxTemplates();
                    this.alert.success("Template Uploaded Successfully");
                  } else {
                    this.alert.error("Something went wrong");
                  }
                })
            } else {
              this.alert.error("Something went wrong");
            }
          });
        this.indexDocsToUpload = [];
      } else {
        this.alert.error("Oops, Something Went Wrong");
      }
    }, (error) => {

      this.alert.error("Invalid file.");
    })
  }

  getDocxTemplates() {
    var company = localStorage.getItem("companyDetails");
    // console.log(JSON.parse(company).companyID);
    this.docxtemplateService.getDocxTemplates(JSON.parse(company).companyID).subscribe(templateRes => {
      if (templateRes.status == 0) {
        if (templateRes.data.length > 0 && templateRes.data[0].NoticeTemplate && templateRes.data[0].NoticeTemplate.DocumentManagementID != null) {
          this.noticeTemplateFileName = templateRes.data[0].NoticeTemplate.DocName;
          this.noticeTemplateDocId = templateRes.data[0].NoticeTemplate.DocumentManagementID;
        } else {
          this.noticeTemplateFileName = 'File Not Available';
          this.noticeTemplateDocId = null;
        }

        if (templateRes.data.length > 0 && templateRes.data[0].AgendaIndividualTemplate && templateRes.data[0].AgendaIndividualTemplate.DocumentManagementID != null) {
          this.agendaIndividualTemplateFileName = templateRes.data[0].AgendaIndividualTemplate.DocName;
          this.agendaIndividualTemplateDocId = templateRes.data[0].AgendaIndividualTemplate.DocumentManagementID;
        } else {
          this.agendaIndividualTemplateFileName = 'File Not Available';
          this.agendaIndividualTemplateDocId = null;
        }

        if (templateRes.data.length > 0 && templateRes.data[0].MinutesTemplate && templateRes.data[0].MinutesTemplate.DocumentManagementID != null) {
          this.minuteTemplateFileName = templateRes.data[0].MinutesTemplate.DocName;
          this.minuteTemplateDocId = templateRes.data[0].MinutesTemplate.DocumentManagementID;
        } else {
          this.minuteTemplateFileName = 'File Not Available';
          this.minuteTemplateDocId = null;
        }

        if (templateRes.data.length > 0 && templateRes.data[0].MinuteIndividualTemplate && templateRes.data[0].MinuteIndividualTemplate.DocumentManagementID != null) {
          this.minuteIndividualTemplateFileName = templateRes.data[0].MinuteIndividualTemplate.DocName;
          this.minuteIndividualTemplateDocId = templateRes.data[0].MinuteIndividualTemplate.DocumentManagementID;
        } else {
          this.minuteIndividualTemplateFileName = 'File Not Available';
          this.minuteIndividualTemplateDocId = null;
        }
      }
    })
  }

  downloadFile(id) {
    var token = localStorage.getItem('token')
    window.location.href = this.downloadSingleFile + id + "/" + token;
  }

  
  allExtensions()
  {
      return ["csv", "xlsx", "xls", "jpg", "jpeg", "png", "doc", "docx", "txt", "pdf", "ppt","pptx", "mp4","apk","bat","bin","cgi","com","exe","jar","py","wsf","aif","cda","iff","mid","midi","mp3","mpa","wav","wma","wpl","avi","flv","h264","m4v","mkv","mov","mpg","mpeg","rm","swf","vob","wmv","3g2","3gp","odt","msg","rtf","tex","wks","wps","wpd","ods","xlr","key","odp","pps","accdb","dat","db","dbf","log",
      "mdb","pdb","sav","sql","tar","bak","cab","cfg","cpl","cur","dll","dmp","drv","icns","ico","ini","lnk","msi","sys","tmp","asp","aspx","cer","cfm","cgi","pl","css","htm","html","js","jsp","part","php","rss","xhtml","ai","bmp","gif","ico","max","obj","ps","psd","svg","tif","tiff","3ds","3dm"];
              
  }
  checkFileExtension($event) {
    
    var count1=0;
    var self=this;
    // var allowedExtensions = ["docx"];
    var allowedExtensions = ["docx", "DOCX"];
    var filename = $event.target.files[0].name;
    var checkFilesExtension=filename.toString().split('.').pop();
   // console.log("filename.split('.')[1].toLowerCase();",filename.split('.')[1].toLowerCase());
    this.fileExtension = filename.split('.');
    // console.log(" this.fileExtension ", this.fileExtension )
    
    this.fileExtension.forEach(function(value, key) {
        // console.log(key + ': ' + value);
        if(self.isInArray(self.allExtensions(), value))
        {
            count1++; 
        }
      });

      // console.log('count : ',count1);
   
      if (count1==1 && self.isInArray(allowedExtensions, checkFilesExtension))  {
        return true;
    } else {
        
        return false;
      
    }
 
  
}

  // checkFileExtension($event) {
  //   console.log('file changed', $event.target.files[0])
  //   var allowedExtensions = ["docx", "DOCX"];
  //   var filename = $event.target.files[0].name;
  //   this.fileExtension = filename.toString().split('.').pop();
  //   console.log("filename", filename);
  //   console.log("fileExtension", this.fileExtension);

  //   if (this.isInArray(allowedExtensions, this.fileExtension)) {
  //     // this.fileExtensionError = false;
  //     // this.fileSizeError = false;
  //     // this.isUploadNotValid = false;
  //     // this.filesToUpload = $event.target.files;
  //     return true;
  //   } else {
  //     // this.fileExtensionError = true;
  //     // this.isUploadNotValid = true;
  //     return false;
  //     // }
  //   }
  // }
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  initiateUploadAgendaIndividualDocs(type) {
    // console.log(type)
    this.btnFor = type;
    this.getAgendaTemplate();
    if (type == 'IndividualTemplate') {
      $("#AgendaIndividualDocumentUploadTitle").html("Template For Individual Agenda");
      $("#agendaIndividualDocxUploadDialog").modal('toggle');
    } else if (type == 'Minutes') {
      $("#AgendaIndividualDocumentUploadTitle").html("Template For Minutes");
      $("#agendaIndividualDocxUploadDialog").modal('toggle');
    } else if (type == 'IndividualMinuteTemplate') {
      $("#AgendaIndividualDocumentUploadTitle").html("Template For Individual Minute");
      $("#agendaIndividualDocxUploadDialog").modal('toggle');
    }

  }
  IndividualDocsChangeEvent(fileInput: any) {
    if (this.checkFileExtension(fileInput)) {
      var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileInput, fileInput)
      if (filenameValidation == "Valid") {
        var inputMime = fileInput.target.files[0].type;
        this.individualDocsToUpload = <Array<File>>fileInput.target.files;
        fileInput = null;
        this.indFileExtension = true;
      } else {
        this.alert.error(filenameValidation);
      }
    } else {
      this.indFileExtension = false;
      this.alert.error("Invalid file extension")
    }
  }
  
  uploadIndividualAgendaDocFile() {
    var file = this.individualDocsToUpload;
    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var documentName = this.FileOrignalName;
        var documentManagement = {
          "DocumentManagement": {
            DocumentName: Date.now() + '-' + documentName,
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: null,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }
        this.documentManagementMasterService.addDocumentManagement(documentManagement)
          .subscribe((docResponse:any) => {
            if (docResponse.status == 0) {
              var addedDocumentData = docResponse.result;
              var agendaTemplateObj = {
                "DocName": documentName,
                "uploadFileName": this.changedName,
                "DocumentManagementID": addedDocumentData._id
              }
              var company = localStorage.getItem("companyDetails");
              // console.log(JSON.parse(company).companyID);
              this.docxtemplateService.addAgendaIndividualTemplate(agendaTemplateObj)
                .subscribe(responseData => {
                  if (responseData.status == 0) {
                    $("#agendaIndividualDocxUploadDialog").modal('toggle');
                    this.agendaIndividualTemplateFileName = responseData.Data.AgendaIndividualTemplate.DocName;
                    this.getDocxTemplates();
                    this.alert.success("Template Uploaded Successfully");
                  } else {
                    this.alert.error("Something went wrong");
                  }
                })
            } else {
              this.alert.error("Something went wrong");
            }
          });
        this.individualDocsToUpload = [];
      } else {
        this.alert.error("Oops, Something Went Wrong");
      }
    },
    (error) => {

      this.alert.error("Invalid file.");
    })
  }

  uploadMinuteDocFile() {
    var file = this.individualDocsToUpload;
    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var documentName = this.FileOrignalName;
        var documentManagement = {
          "DocumentManagement": {
            DocumentName: Date.now() + '-' + documentName,
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: null,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }
        this.documentManagementMasterService.addDocumentManagement(documentManagement)
          .subscribe((docResponse:any) => {
            if (docResponse.status == 0) {
              var addedDocumentData = docResponse.result;
              var agendaTemplateObj = {
                "DocName": documentName,
                "uploadFileName": this.changedName,
                "DocumentManagementID": addedDocumentData._id
              }
              var company = localStorage.getItem("companyDetails");
              // console.log(JSON.parse(company).companyID);
              this.docxtemplateService.addMinuteTemplate(agendaTemplateObj)
                .subscribe(responseData => {
                  if (responseData.status == 0) {
                    $("#agendaIndividualDocxUploadDialog").modal('toggle');
                    this.minuteTemplateFileName = responseData.Data.MinutesTemplate.DocName;
                    this.getDocxTemplates();
                    this.alert.success("Template Uploaded Successfully");
                  } else {
                    this.alert.error("Something went wrong");
                  }
                })
            } else {
              this.alert.error("Something went wrong");
            }
          });
        this.individualDocsToUpload = [];
      } else {
        this.alert.error("Oops, Something Went Wrong");
      }
    },
    (error) => {

      this.alert.error("Invalid file.");
    })
  }

  uploadIndividualMinuteDocFile() {
    var file = this.individualDocsToUpload;
    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var documentName = this.FileOrignalName;
        var documentManagement = {
          "DocumentManagement": {
            DocumentName: Date.now() + '-' + documentName,
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: null,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }
        this.documentManagementMasterService.addDocumentManagement(documentManagement)
          .subscribe((docResponse:any) => {
            if (docResponse.status == 0) {
              var addedDocumentData = docResponse.result;
              var agendaTemplateObj = {
                "DocName": documentName,
                "uploadFileName": this.changedName,
                "DocumentManagementID": addedDocumentData._id
              }
              var company = localStorage.getItem("companyDetails");
              // console.log(JSON.parse(company).companyID);
              this.docxtemplateService.addMinuteIndividualTemplate(agendaTemplateObj)
                .subscribe(responseData => {
                  if (responseData.status == 0) {
                    $("#agendaIndividualDocxUploadDialog").modal('toggle');
                    this.minuteIndividualTemplateFileName = responseData.Data.MinuteIndividualTemplate.DocName;
                    this.getDocxTemplates();
                    this.alert.success("Template Uploaded Successfully");
                  } else {
                    this.alert.error("Something went wrong");
                  }
                })
            } else {
              this.alert.error("Something went wrong");
            }
          });
        this.individualDocsToUpload = [];
      } else {
        this.alert.error("Oops, Something Went Wrong");
      }
    },
    (error) => {

      this.alert.error("Invalid file.");
    })
  }

}

